import { apiClient } from './client';
import type { ApiResponse } from './types';

export async function manuallyLock(tenantId: number, tenantCode: string, reason: string) {
  const r = await apiClient.post<ApiResponse<null>>(`/ops/tenants/${tenantId}/manually-lock`, {
    tenantCode,
    reason,
  });
  return r.data;
}

export async function unlock(tenantId: number, tenantCode: string) {
  const r = await apiClient.post<ApiResponse<null>>(`/ops/tenants/${tenantId}/unlock`, { tenantCode });
  return r.data;
}

export interface ResetAdminResult {
  newPassword: string;
  generated: boolean;
}
/** newPassword 省略时由后端生成强密码并返回（一次性明文） */
export async function resetAdmin(tenantId: number, tenantCode: string, newPassword?: string) {
  const r = await apiClient.post<ApiResponse<ResetAdminResult>>(`/ops/tenants/${tenantId}/reset-admin`, {
    tenantCode,
    ...(newPassword ? { newPassword } : {}),
  });
  return r.data.data!;
}

export async function triggerBackup(tenantId: number, tenantCode: string) {
  const r = await apiClient.post<ApiResponse<null>>(`/ops/tenants/${tenantId}/trigger-backup`, {
    tenantCode,
  });
  return r.data;
}

export async function schedulePurge(tenantId: number, tenantCode: string) {
  const r = await apiClient.post<ApiResponse<null>>(`/ops/tenants/${tenantId}/schedule-purge`, {
    tenantCode,
  });
  return r.data;
}

export interface BackupFile {
  key: string;
  size: number;
  last_modified: string;
}

export async function listBackups(tenantId: number) {
  const r = await apiClient.get<ApiResponse<{ items: BackupFile[] }>>(`/ops/tenants/${tenantId}/backups`);
  return r.data.data!.items;
}

export async function restoreBackup(tenantId: number, tenantCode: string, backupKey: string) {
  const r = await apiClient.post<ApiResponse<null>>(`/ops/tenants/${tenantId}/restore`, {
    tenantCode,
    backupKey,
  });
  return r.data;
}
